import { initialState } from './state';

export function setNodes(state, patientUsers) {
  if (!patientUsers || !patientUsers.edges) return;
  Object.assign(state, { nodes: patientUsers.edges.map(({ node }) => node) });
}

export function clearNodes(state) {
  Object.assign(state, { nodes: [] });
}

export function selectPatient(state, selectedPatient) {
  Object.assign(state, { selectedPatient });
}

export function reset(state) {
  Object.assign(state, initialState());
  Object.assign(state, { isResetRequired: false });
}

export function requireReset(state) {
  Object.assign(state, { isResetRequired: true });
}
